<template>
    <div class="overflow-auto">
        <b-container fluid class="bv-example-row">
            <Create ref="createNew"></Create>
            <b-row>
                <b-col md="4">
                    <b-button block variant="primary" @click="openCreate">{{$t('create_configuration')}}</b-button>
                </b-col>
                <b-col md="2">
          <span class="text-nowrap">
                        {{$t('configurations_selected')+ ': ' + rows}}
                    </span>
                </b-col>
                <b-col md="4" offset-md="2">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-container>
        <b-table dark
                id="my-table"
                :items="myProvider"
                :per-page="perPage"
                :current-page="currentPage"
                :hover="hover"
                head-variant="dark"
                small
                @row-selected="onRowSelected"
                :fields="fields"
                no-local-sorting
                :filter="filters"
                :filterIncludedFields="filterOn"
                stacked="md"
                :filter-function="onFilter"
                striped
                 sort-desc
                 sort-by="regDate"
        >
            <template v-slot:head()="scope">
                <div class="text-nowrap">
                    {{ $t(scope.label) }}
                </div>
            </template>

            <template v-slot:cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                </template>
            </template>
            <template v-slot:cell(settings)="row">
                <router-link :to="{ name: 'savedConfiguration', params: { id: row.item.id }}" ><b-icon-tools></b-icon-tools></router-link>
            </template>
            <template v-slot:cell(isDefault)="row">
                <b-form-checkbox v-model="row.item.isDefault" disabled></b-form-checkbox>
            </template>
            <template v-slot:cell(isActive)="row">
                <b-form-checkbox v-model="row.item.isActive" disabled></b-form-checkbox>
            </template>
            <template slot="thead-top" slot-scope="{ fields }">
                <td v-for="field in fields" :key="field.key">
                    <div v-if="field.filteredType === 'select'">
                        <b-form-select
                            v-if="field.filtered === true"
                            v-model="filters[field.key]"
                            :style="{width: field.width + 'px'}"
                            :options="getDictionary(field.dictionaryName)"
                            value-field="id"
                            text-field="name"
                        />

                    </div>
                    <div v-else>
                        <b-input
                            v-if="field.filtered === true"
                            v-model="filters[field.key]"
                            :placeholder="$t(field.label)"
                            :style="{width: field.width + 'px'}"
                            :min="field.min"
                            :max="field.max"
                        />
                    </div>
                </td>
            </template>
        </b-table>
    </div>
</template>

<script>
    import axios from 'axios';

    import Create from './Create';

    export default {
        name: "SavedConfigurationList",
        components: {Create},
        data() {
            return {
                filter: null,
                filterOn: [],
                isBusy: true,
                perPage: Math.floor(document.documentElement.clientHeight/44),
                currentPage: 1,
                deviceTypeList: [],
                rows: 0,
                fields: [
                    {
                        key: 'settings',
                        label: 'device_configuration_list.coll.header.settings',
                        sortable: false,
                        stickyColumn: true
                    },
                    {
                        key: 'name',
                        label: 'device_configuration_list.coll.header.name',
                        sortable: true,
                        stickyColumn: true,
                        filtered: true,
                    },
                    {
                        key: 'deviceType',
                        label: 'device_configuration_list.coll.header.deviceTypeName',
                        sortable: true,
                        filtered: true,
                        filteredType: 'select',
                        dictionaryName: 'deviceType',
                    },
                    {
                        key: 'isActive',
                        label: 'device_configuration_list.coll.header.isActive',
                        sortable: true,
                    },
                    {
                        key: 'distributor',
                        label: 'device_configuration_list.coll.header.distributor',
                        sortable: true,
                        filtered: true,
                    },
                    {
                        key: 'regDate',
                        label: 'device_configuration_list.coll.header.created_at',
                        sortable: true,
                        filtered: true,
                    },
                ],
                // items: [ ],
                small: true,
                bordered: true,
                hover: true,
                filters: {
                    name: null,
                    type: null,
                    distributor: null,
                    deviceType: null,
                },
                breadcrumb: [
                    {
                        text: 'Admin',
                        href: '#'
                    },
                    {
                        text: 'Manage',
                        href: '#'
                    },
                    {
                        text: 'Library',
                        active: true
                    }
                ],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                }
            }
        },
        computed: {
            // rows() {
            //     return this.items.length
            // }
        },
        methods: {
            openCreate() { this.$refs.createNew.show() },
            onFilter: function() {
                // alert(11);
              // console.log('onFilter');
            },
            onRowSelected(items) {
                this.selected = items
            },
            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`
                this.infoModal.content = JSON.stringify(item, null, 2)
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            onFiltered(filteredItems) {
                // console.log(this.filters)
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            myProvider (ctx) {
                // console.log(ctx)
                // Here we don't set isBusy prop, so busy state will be
                // handled by table itself
                let params = '?page='
                    + ctx.currentPage
                    + '&rows=' + ctx.perPage
                    + '&sortBy=' + ctx.sortBy
                    + '&sortOrder=' + (ctx.sortDesc ? 'desc': 'asc')

                for (let field in this.filters) {
                    if (this.filters[field] !== null) {
                        params += "&" + field + "=" +  this.filters[field];
                    }
                }

                this.isBusy = true
                let promise = axios.get('api/v1/saved-configurations' + params)

                return promise.then((data) => {
                    const items = data.data.data
                    // Here we could override the busy state, setting isBusy to false
                    this.rows = data.data.records
                    this.isBusy = false

                    return(items)
                }).catch(() => {
                    // Here we could override the busy state, setting isBusy to false
                    // this.isBusy = false
                    // Returning an empty array, allows table to correctly handle
                    // internal busy state in case of error
                    // console.log(error)
                    return []
                })
            },
            getDictionary: function(type) {
                if (type=== 'deviceType') {
                    return this.deviceTypeList
                }

                return []
            },
        },
        mounted() {
            axios
                .get('api/v1/devices/device-types')
                .then((data) => {
                    this.deviceTypeList = [
                        {
                            id: null,
                            name: this.$t('select_type'),
                            selected: true
                        }
                    ]

                    this.deviceTypeList = this.deviceTypeList.concat(data.data.rows)
                    this.isBusy = false;
                })
                .catch(() => undefined);
        }
    }
</script>

<style scoped>

</style>